import { styled } from "@mui/material";

export const Header = styled("div")({
  height: "76px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
});

export const LogoWrapper = styled("div")({
  // display: 'flex',
  // alignItems: 'center',
  // justifyContent: 'start'
  position: "absolute",
  left: "25px",
});

export const SearchWrapper = styled("div")({
  display: "flex",
  flexDirection: "column",
  // alignItems: 'center',
  justifyContent: "center",
  // width: '686px',
  width: "48%",

  position: "relative",
});

export const SearchingItemsWrapper = styled("div")({
  maxHeight: "400px",
  width: "100%",
  overflowY: "auto",
  background: "white",
  borderBottomRightRadius: "8px",
  borderBottomLeftRadius: "8px",

  boxShadow: "0px 10px 13px rgba(17, 38, 146, 0.05)",

  position: "absolute",
  zIndex: 9999,
  top: 40,
});

export const SearchItem = styled("div")({
  textAlign: "start",
  padding: "20px",
  cursor: "pointer",

  "&:not(:last-child)": {
    borderBottom: "1px solid #dbdbdb",
  },
});
